import { TabsProps } from 'antd';

import Tabs from '@/components/shared/Tabs';
import { useAppSelector } from '@/hooks/redux';
import styled, { StyledProp, css } from '@/styled';

import CommentsTabs from './CommentsTabs';
import ContactTab from './ContactTab';
import ModulesTab from './ModulesTab';

const CourseTabs = (props: StyledProp) => {
  const user = useAppSelector(state => state.auth.user);
  const tabs = ['Módulos'];
  if (user) tabs.push('Meus Comentários', 'Falar com produtor');
  return (
    <Tabs
      className={props.className}
      items={
        tabs.map((label, key) => ({
          label,
          key: String(key),
          // eslint-disable-next-line react/jsx-key
          children: [<ModulesTab />, <CommentsTabs />, <ContactTab />][key]
        })) as TabsProps['items']
      }
    />
  );
};

export default styled(CourseTabs)`
  ${({ theme }) => {
    return css`
      .ant-tabs-tabpane {
        background: ${theme.variables.tabs.contentBackground};

        ${theme.breakpoints.down('lg')} {
          padding: ${theme.space.spacing(6, 4)};
        }
      }
    `;
  }}
`;
